import { GrowthWithColor } from '../utils';

export interface FilterValues {
    statusList: number[];
    datumVon: string;
    datumBis: string;
    kNr?: number;
    kName?: string;
    konzernNr?: number;
    konzernName?: string;
    kundeArt?: string[];
    kundePlzVon?: string;
    kundePlzBis?: string;
    kundeUmsatzTsdVon: number;
    kundeUmsatzTsdBis: number;
    kundeBranchen?: number[];
    kundeInteresseFuerProdukte?: number[];
    kundeErweiterteSuchen?: number[];
    kundeBetreuer?: number;
    kundeTelBetreuer?: number;
    betreuer?: number;
    betreuerGebiet?: boolean;
    telBetreuer?: number;
    telBetreuerGebiet?: boolean;
    produktgruppen?: number[];
    showBetreuer?: boolean;
    showTelBetreuer?: boolean;
    showDetails?: boolean;
    show3d?: boolean;
    previousYear1?: boolean;
    previousYear2?: boolean;
    previousYear3?: boolean;
}

export interface LineData {
    auNr: string;
    kNr: number;
    kName: string;
    datum: string;
    count: number;
    betreuerNr: number;
    name: string;
    ekNetto: number;
    vkNetto: number;
    bMarge: number;
    tippProv: number;
    skonto: number;
    fracht: number;
    nMarge: number;
    bAnteil: number;
    fAnteil: number;
    betrUmCount: number;
    betrUm: number;
}

export const defaultLineData: LineData = {
    auNr: '',
    kNr: 0,
    kName: '',
    datum: '',
    betreuerNr: 0,
    count: 0,
    name: '',
    ekNetto: 0,
    vkNetto: 0,
    bMarge: 0,
    tippProv: 0,
    skonto: 0,
    fracht: 0,
    nMarge: 0,
    bAnteil: 0,
    fAnteil: 0,
    betrUmCount: 0,
    betrUm: 0,
};

export interface LineDataWithGrowth extends LineData {
    ekNettoPrevGrowth: GrowthWithColor;
    ekNettoAvgGrowth: GrowthWithColor;
    vkNettoPrevGrowth: GrowthWithColor;
    vkNettoAvgGrowth: GrowthWithColor;
    bMargePrevGrowth: GrowthWithColor;
    bMargeAvgGrowth: GrowthWithColor;
    tippProvPrevGrowth: GrowthWithColor;
    tippProvAvgGrowth: GrowthWithColor;
    skontoPrevGrowth: GrowthWithColor;
    skontoAvgGrowth: GrowthWithColor;
    frachtPrevGrowth: GrowthWithColor;
    frachtAvgGrowth: GrowthWithColor;
    nMargePrevGrowth: GrowthWithColor;
    nMargeAvgGrowth: GrowthWithColor;
    bAnteilPrevGrowth: GrowthWithColor;
    bAnteilAvgGrowth: GrowthWithColor;
    fAnteilPrevGrowth: GrowthWithColor;
    fAnteilAvgGrowth: GrowthWithColor;
}

export interface AuftragSummary {
    loading: boolean;
    count: number;
    total: LineData;
    betreuerTotal: {
        [key: number]: LineData;
    };
    telBetreuerTotal: {
        [key: number]: LineData;
    };
    auftragLineDataList: LineData[];
    fAnteilTotal: number;
    usedProduktgruppen?: Record<string, number>;
}

export interface Pillar {
    x: number;
    y: number;
    height: number;
    color: string;
    kNr: number;
    kName: string;
    totalNetto: number;
    auNrList: string[];
    month: string;
    value: number;
}

export interface AxisLabel {
    type: 'kunde' | 'month';
    label: string;
    x: number;
    y: number;
}
